import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToCTA = () => {
    document.getElementById('cta-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-gradient-to-b from-emerald-50/50 to-stone-50" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-30">
            <span className="inline-block py-1 px-3 rounded-full bg-emerald-100 text-emerald-800 text-sm font-semibold tracking-wide mb-6" data-id="element-31">
              NUEVO PROTOCOLO
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-stone-900 leading-tight mb-6" data-id="element-32">
              El Protocolo Anti-Inflamación:{' '}
              <span className="text-emerald-600" data-id="element-33">
                El Plan de 30 Días para Recuperar tu Abdomen
              </span>
            </h1>
            <p className="text-lg md:text-xl text-stone-600 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-34">
              Apaga la señal de estrés de tu cuerpo, elimina la retención de
              líquidos y vuelve a cerrar ese pantalón en solo 72 horas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-35">
              <Button size="lg" href="https://www.rutinavital.com/cart/47900606857460:1" data-id="element-36">
                QUIERO DESINFLAMARME AHORA
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-37">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-emerald-900/10" data-id="element-38">
              <img src="https://cdn.magicpatterns.com/uploads/cFUfdYme6KXfWBA96LUGay/heylloyd-image-1774468813334.png" alt="Protocolo Anti-Inflamación en tablet con salpicadura de agua y pepino" className="w-full h-auto object-cover" data-id="element-39" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-amber-400/20 rounded-full blur-2xl" data-id="element-40"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-emerald-400/20 rounded-full blur-2xl" data-id="element-41"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}